export default {
  props: {
    name: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      required: true
    }
  }
};
